
import {Vue, Component} from 'vue-property-decorator';
import {deleted, listMarkType, locked, search} from "@/api/mark-management";
import CreateOrEdit, {MarkForm} from "@/views-oms/package-info-management/markManagement/components/CreateOrEdit.vue";
import Pagination from "@/components/Pagination/index.vue";

@Component({ name: "markManagement",
  components: {Pagination, CreateOrEdit}
})
export default class index extends Vue {
  private customerId = "" as any;
  private customerInfo = {} as any;
  private header = {} as any;
  private headerFields = [
    {label: "客人简称", key: "customerAbbr"},
    {label: "客人编号", key: "customerCode"},
    {label: "销售员", key: "seller"}
  ];

  private queryFields = [
    {
      label: "名称",
      prop: "name",
      key: "name",
      type: "input",
      value: "",
    },
    {
      label: "类型",
      prop: "markType",
      key: "markType",
      type: "select",
      clearable: true,
      value: "",
      options: [],
      resetKey: { label: "name", value: "id" },
    },
  ];

  private title = "";
  private markType = "";
  private creatOrEdit = false;
  private tableData = {
    total: 0,
    pageNumber: 1,
    pageSize: 20,
    list: [] as any[],
  };
  private tableCol = [
    {
      label: "S/N",
      prop: "sn",
      key: "sn",
      show: true,
      fixed: true,
      disabled: false,
      width: 20
    },
    {
      label: "名称",
      prop: "name",
      key: "name",
      show: true,
      disabled: false,
    },
    {
      label: "品牌",
      prop: "brand",
      key: "brand",
      show: true,
      disabled: false,
    },
    {
      label: "类型",
      prop: "markTypeDesc",
      key: "markTypeDesc",
      show: true,
      disabled: false,
    },
    {
      label: "操作",
      prop: "actions",
      key: "actions",
      type: "actions",
      options: [
        {
          name: "锁定",
          code: "",
          click: "locked",
          key: "lock",
          value: false
        },
        {
          name: "取消锁定",
          code: "",
          click: "locked",
          key: "lock",
          value: true
        },
        {
          name: "删除",
          code: "",
          click: "deleted",
        },
        {
          name: "编辑",
          code: "",
          click: "edit",
        }
      ],
      show: true,
      disabled: false,
      width: 80,
    },
  ];

  private listParam = {
    customerId: null,
    name: null,
    markType: null,
  }

  private editBoolean = false;

  private rowData = new MarkForm();

  created() {
    this.customerId = this.$route.query.customerId;
    this.customerInfo = JSON.parse(this.$route.query.item as string);
    this.header = this.customerInfo;
    this.init();
  }

  private init() {
    this.getMarkType();
    this.getList();
  }

  private async getList() {
    this.listParam.customerId = this.customerId;
    const params = {
      ...this.listParam,
      pageNumber: this.tableData.pageNumber,
      pageSize: this.tableData.pageSize
    };
    const {total, list}: any = await search(params);
    this.tableData.total = +total;
    this.tableData.list = list;
    this.tableData.list.map((e,index) => {
      e.sn = index + 1
    });
  }

  private search(data) {
    this.listParam = data;
    this.getList();
  }

  private async getMarkType() {
    const res: any = await listMarkType();
    res.forEach(item => {
      item.id = item.name;
      item.name = item.desc;
    });
    this.queryFields[1].options = res;
  }

  private handleCommand(command) {
    this.title = "新建唛头";
    this.editBoolean = false;
    this.markType = command;
    this.creatOrEdit = true;
  }

  private async edit(scope) {
    console.log(scope.row);
    const row = scope.row;
    this.rowData = row;
    if (row.markType === "CTN_MARK" || row.markType === "PLT_MARK") {
      if (row.custom) {
        this.markType = "customMark";
      }else {
        this.markType = "normalMark";
      }
    }
    if (row.markType === "OTHER_MARK") {
      this.markType = "otherMark";
    }
    this.title = "编辑唛头";
    this.editBoolean = true;
    this.creatOrEdit = true;
  }

  private closeDialog() {
    console.log("清理rowData");
    this.rowData = new MarkForm();
  }

  private async deleted(scope) {
    await deleted(scope.row.id);
    await this.getList();
  }

  private async locked(scope) {
    await locked(scope.row.id);
    await this.getList();
  }

}
